<template>
  <ul class="live-upcoming-list">
    <li v-if="showEvent(event)" v-for="event in events" :key="event.id">
      <div class="sport">{{ event.sport.name }}</div>
      <div class="time">{{ event.time | moment('DD/MM HH:mm') }}</div>
      <div class="event">{{ event.name }}</div>
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      events: state => state.live.upcoming.events,
      time: state => state.live.upcoming.time
    })
  },
  methods: {
    showEvent (event) {
      return (!this.$route.params.sport || parseInt(this.$route.params.sport) === event.sport.id)
    }
  }
}
</script>

<style scoped>
.live-upcoming-list { color: #aaa; list-style: none; margin-right: 10px; margin-top: 5px; }
.live-upcoming-list li { background: rgba(255, 255, 255, .05); display: flex; height: 40px; line-height: 40px; padding: 0 15px; }
.live-upcoming-list li:nth-child(even) { background: rgba(255, 255, 255, .025) }
.live-upcoming-list li:not(:first-child) { margin-top: 1px; }
.sport { width: 160px; }
.time { width: 80px; }
.event { color: #fff; flex: 1; }
</style>



// WEBPACK FOOTER //
// src/components/live/upcoming/List.vue